import React, { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import RemoveIcon from '@material-ui/icons/Remove';
import CheckIcon from '@material-ui/icons/Check';

import './CodeSystemDialogRows.css';

const columns = [
	{ id: 'code', label: 'Code', minWidth: 150 },
	{ id: 'display', label: 'Display', minWidth: 170 },
	{
		id: 'definition',
		label: 'Definition',
		minWidth: 170,
		align: 'left',
		format: (value) => value.toLocaleString('en-US'),
	},
	{
		id: 'hasDesignation',
		label: 'Designation',
		minWidth: 70,
		align: 'center',
	},
	{
		id: 'hasProperty',
		label: 'Property',
		minWidth: 70,
		align: 'center',
	},
	{
		id: 'hasChildren',
		label: 'Children',
		minWidth: 70,
		align: 'center',
	},
];

function createDataRows(concept) {
	if (concept) {
		return concept.map((concept) => createData(concept));
	}
	return {};
}

function createData(concept) {
	// console.log('cc', concept);
	const code = concept.code;
	const display = concept.display;
	const definition = concept.definition;
	const hasDesignation = concept.designation;
	const hasProperty = concept.property ? true : false;
	const hasChildren = concept.concept ? true : false;

	return {
		code,
		display,
		definition,
		hasDesignation,
		hasProperty,
		hasChildren,
	};
}

const useStyles = makeStyles({
	root: {
		width: '100%',
	},
});

const StyledTableCell = withStyles((theme) => ({
	head: {
		backgroundColor: '#383838',
		color: theme.palette.common.white,
	},
	body: {
		fontSize: 14,
	},
}))(TableCell);

export default function CodeSystemDialogRows(props) {
	const classes = useStyles();
	const dataRows = createDataRows(props.concept);
	const dataRowsCount = dataRows.length;
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	useEffect(() => {
		if (props) {
			// console.log('props', props);
			// console.log('props', props.resourceType);
		}
	});


	function displayTable() {
		if (dataRowsCount > 0)
			return (<Paper className={classes.root}>
				<TableContainer className="csTable__container">
					<Table stickyHeader className="csTable__tableHeader" size="small" aria-label="sticky table">
						<TableHead className="csTable__tableHeader">
							<TableRow>
								{columns.map((column) => (
									<StyledTableCell
										key={column.id}
										align={column.align}
										style={{ minWidth: column.minWidth }}
									>
										{column.label}
									</StyledTableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{dataRows
								.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
								.map((row) => {
									return (
										<TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
											<TableCell key={columns[0].id} align={columns[0].align}>
												{row[columns[0].id]}
											</TableCell>

											<TableCell key={columns[1].id} align={columns[1].align}>
												{row[columns[1].id]}
											</TableCell>

											<TableCell key={columns[2].id} align={columns[2].align}>
												{row[columns[2].id]}
											</TableCell>

											<TableCell key={columns[3].id} align={columns[3].align}>
												{(() => {
													if (row[columns[3].id]) {
														return <CheckIcon />;
													} else {
														return <RemoveIcon className="csTable__dimmed" />;
													}
												})()}
											</TableCell>

											<TableCell key={columns[4].id} align={columns[4].align}>
												{(() => {
													if (row[columns[4].id]) {
														return <CheckIcon />;
													} else {
														return <RemoveIcon className="csTable__dimmed" />;
													}
												})()}
											</TableCell>

											<TableCell key={columns[5].id} align={columns[5].align}>
												{(() => {
													if (row[columns[5].id]) {
														return <CheckIcon />;
													} else {
														return <RemoveIcon className="csTable__dimmed" />;
													}
												})()}
											</TableCell>
										</TableRow>
									);
								})}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[10, 25, 100]}
					component="div"
					count={dataRows.length}
					rowsPerPage={rowsPerPage}
					page={page}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
			</Paper>
			)

		return <SnackbarContent
			message={'No codes have been set for this CodeSystem'}
		/>
	}
	return (
		displayTable()
	);
}
